import { styled, css } from '@mui/material/styles';
import { Box, Button as Btn } from '@mui/material';

export const Container = styled(Box)`
  height: 100%;
  width: 100%;
  overflow-y: overlay;
  background: #f5f5f5;
  padding: 42px 30px;
`;

export const HeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Users = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  gap: 100px;

  width: 100%;
  height: 62px;

  border-top: 1px solid #e0e0e0;
  border-radius: 4px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const Typography = styled(Box)`
  .desc {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;

  width: 100%;
  height: 48px;

  .section-tabs {
    display: flex;
    padding-top: 8px;
    gap: 10px;
    padding-bottom: 8px;
    align-items: center;
  }
  .btn-archives {
    height: 42px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.54);
    white-space: nowrap;
    border-radius: 0px;
  }
  .btn-files {
    height: 42px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.54);
    white-space: nowrap;
    border-radius: 0px;
  }
  .new-file {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
    width: 160px;
    height: 48px;
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: #ffffff;
    font-size: 15px;
    white-space: nowrap;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
`;

interface ButtonProps {
  active: boolean;
}
export const TabButton = styled(Btn)`
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  ${(props: ButtonProps) =>
    props.active &&
    css`
      font-weight: 800;
      border-bottom: 2px solid #206da7;
      color: #206da7;
    `}
`;

export const TabSelection = styled(Box)`
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border-radius: 4px;
  Button {
    width: 160px;
    height: 48px;
    padding: 17px 43px;
    border-radius: 0;
  }
`;

export const Page = styled(Box)`
  width: 100%;

  margin-top: 20px;
  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    color: #000000;
  }
`;

export const CardListLink = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
`;
